export default __webpack_public_path__ + "static/media/learning.868de6bd.PNG";